<mat-checkbox class="mb-4" [(ngModel)]="_bufferAccountActivated" [ngModelOptions]="{ standalone: true }">
  <span class="pr-1">{{ 'settlementaccount.enable_buffer_account' | translate }}</span>
  <mat-icon
    class="align-text-bottom"
    color="primary"
    [matTooltip]="'Add a buffer account in order to process refunds when needed.'"
    >info
  </mat-icon>
</mat-checkbox>

@if (_bufferAccountActivated) {
  <div class="px-4 w-full md:w-3/4 lg:1/2">
    <span class="text-base">
      {{ 'settlementaccount.description_buffer_account' | translate }}
    </span>

    <div class="mt-6">
      <span>{{ 0 | price: null : currencyCode }}</span>
      <mat-form-field class="no-padding-mat-field ml-2" appearance="outline">
        <mat-label>{{ 'settlementaccount.buffer_amount' | translate }}</mat-label>

        <input
          matInput
          type="number"
          [(ngModel)]="targetBufferAmount"
          [ngModelOptions]="{ standalone: true }"
          [required]="true"
          (ngModelChange)="setHasChanges()" />
      </mat-form-field>

      @if (accountId > 0) {
        <button
          class="button-regular ml-6"
          [disabled]="!hasChanges"
          type="button"
          (click)="chkTargetBufferLowerThanCurrentBuffer()">
          {{ 'settlementaccount.button_save' | translate }}
        </button>
      }

      <br />

      @if (isEditMode) {
        <span class="text-gray-400"
          >{{ 'settlementaccount.current_balance' | translate }}
          {{ currentBufferAmount.toString() | currency: currencyCode }}
        </span>
      }
    </div>

    @if (isEditMode) {
      <div class="my-6">
        <div class="font-medium bg-gray-100 rounded-2xl p-4">
          <div class="flex">
            <p class="w-[300px]">{{ 'settlementaccount.pending_payouts' | translate }}</p>
            <p class="font-bold text-xl pl-2">
              {{ pendingPayouts.toString() | currency: currencyCode }}
            </p>
          </div>
          <div class="flex">
            <p class="w-[300px]">{{ 'settlementaccount.pending_refunds' | translate }}:</p>
            <p class="font-bold text-xl pl-2">
              {{ pendingRefunds.toString() | currency: currencyCode }}
            </p>
          </div>
          <hr class="mt-2" />
          <div class="flex mt-2">
            <p class="w-[300px]">{{ 'settlementaccount.available_funds' | translate }}</p>
            <p class="font-bold text-xl pl-2">
              {{ (currentBufferAmount + pendingPayouts - pendingRefunds).toString() | currency: currencyCode }}
            </p>
          </div>
          <!-- <button mat-raised-button type="button" color="primary" (click)="openTopUpBufferAmountModal()">{{'settlementaccount.button_topup' | translate}}</button> -->
        </div>
      </div>
    }
  </div>
}

@if (accountId) {
  <app-buffer-history-table
    [id]="accountId"
    [clubId]="organizerId"
    [currencyCode]="currencyCode"></app-buffer-history-table>
}
